// NORMAL:   ;  DETAIL:  ; CHECKOUT:  ;
const InvoiceListType = {
  NORMAL: 'normal',
  DETAIL: 'detail',
  CHECKOUT: 'checkout',
};

// invoice status
// (0, "open"), (1, "partial paid"), (2, "Paid")
export const invoiceStatus = [
  {
    key: 'open',
    value: 0,
    label: 'Open',
  },
  {
    key: 'partialPaid',
    value: 1,
    label: 'Partially paid',
  },
  {
    key: 'paid',
    value: 2,
    label: 'Paid',
  },
  {
    key: 'overdue',
    value: 3,
    label: 'Overdue',
  },
];

export const releaseStatus = [
  {
    key: 'notReleased',
    value: 1,
    label: 'Not Released',
  },
  {
    key: 'released',
    value: 3,
    label: 'Released',
  },
  {
    key: 'releaseDiscarded',
    value: 4,
    label: 'Release Discarded',
  },
  {
    key: 'releaseCanceled',
    value: 5,
    label: 'Release Canceled',
  },
];

export const filterFormConfig = [
  {
    name: 'invoiceID',
    label: 'invoice.filterStatus.invoiceID',
    required: false,
    default: '',
    fieldType: 'text',
    xs: 12,
    variant: 'filled',
    size: 'small',
    options: releaseStatus,
  },
  {
    name: 'invoiceDateFrom',
    label: 'invoice.filter.invoiceDateFrom',
    required: false,
    default: '',
    fieldType: 'date',
    xs: 6,
    variant: 'filled',
    size: 'small',
    options: releaseStatus,
  },
  {
    name: 'invoiceDateTo',
    label: 'invoice.filter.invoiceDateTo',
    required: false,
    default: '',
    fieldType: 'date',
    xs: 6,
    variant: 'filled',
    size: 'small',
    options: releaseStatus,
  },
];

export const filterFormConfigsTranslationVariables: { [key: string]: string } = {
  status: 'invoice.filterStatus.title', 
  notReleased: 'invoice.releaseStatus.notReleased',
  released: 'invoice.releaseStatus.released',
  releaseDiscarded: 'invoice.releaseStatus.releaseDiscarded',
  releaseCanceled: 'invoice.releaseStatus.releaseCanceled',
};

export const defaultSortKey = 'createdAt';

export const sortIdArr: { [key: string]: string } = {
  id: 'invoiceNumber',
  orderNumber: 'orderNumber',
  createdAt: 'createdAt',
  updatedAt: 'dueDate',
  originalBalance: 'originalBalanceAmount',
  openBalance: 'openBalanceAmount',
  status: 'status',
};

export const exportOrderByArr: { [key: string]: string } = {
  invoiceNumber: 'invoice_number',
  orderNumber: 'order_number',
  createdAt: 'created_at',
  dueDate: 'due_date',
  originalBalanceAmount: 'original_balance_amount',
  openBalanceAmount: 'open_balance_amount',
};
export default InvoiceListType;
